import React from "react";
import _ from "underscore";
import { Field } from "redux-form";

class InputText extends React.Component {
  renderField = ({ input, value, meta: { error } }) => {
    var className = "form-control";
    if (error) {
      className = "form-control is-invalid";
    } else {
      if (this.props.field.required) {
        className = "form-control is-valid";
      }
      if (this.props.field.regex && !_.isEmpty(input.value)) {
        className = "form-control is-valid";
      }
    }

    var type =
      this.props.name === "email"
        ? "email"
        : this.props.name === "password1" || this.props.name === "password2"
        ? "password"
        : "text";

    return (
      <div>
        <label htmlFor={this.props.name} className="font-weight-bold">
          {this.props.text + (this.props.field.required ? " *" : "")}
        </label>
        <input
          aria-hidden="true"
          id={this.props.name}
          type={type}
          autoComplete={this.props.autoComplete}
          autoCapitalize={this.props.autoCapitalize}
          className={className}
          required={this.props.field.required}
          placeholder={this.props.name === "email" ? "me@example.org" : ""}
          {...input}
        />
        {true && error && <span className="color-red">{error}</span>}
      </div>
    );
  };

  required = value => (value || !this.props.field.required ? undefined : true);
  regex = value => {
    if (
      value &&
      this.props.field.regex &&
      !(this.props.name === "password1" || this.props.name === "password2")
    ) {
      var regEx = new RegExp(this.props.field.regex);
      return regEx.test(value)
        ? undefined
        : this.props.field.regexText
        ? this.props.field.regexText
        : true;
    }
    return undefined;
  };

  render() {
    if (!this.props.field.visible) {
      return "";
    }

    return (
      <div className="form-group">
        <Field
          component={this.renderField}
          name={this.props.name}
          validate={[this.required, this.regex]}
          autoComplete={this.props.autoComplete}
          autoCapitalize={this.props.autoCapitalize}
        />
      </div>
    );
  }
}

export default InputText;






// WEBPACK FOOTER //
// ./src/components/InputText.js